/* NYXO — product.js
   Variant matching, price/media/URL sync, gallery, zoom, sticky ATC. */
(function () {
  'use strict';
  var root = document.querySelector('[data-pdp]');
  if (!root) return;

  var dataEl = root.querySelector('[data-product-json]');
  var product = null;
  try { product = JSON.parse(dataEl.textContent); } catch (err) { return; }

  var picker = root.querySelector('[data-variant-picker]');
  var idInput = root.querySelector('[data-variant-id]');
  var priceWrap = root.querySelector('[data-pdp-price] .price');
  var availability = root.querySelector('[data-availability]');
  var atc = root.querySelector('[data-atc]');
  var atcLabel = root.querySelector('[data-atc-label]');
  var stickyBtn = root.querySelector('[data-sticky-btn]');
  var stickyPrice = root.querySelector('[data-sticky-price]');

  function formatMoney(cents) {
    var format = (window.NYXO && window.NYXO.moneyFormat) || '${{amount}}';
    var amount = (cents / 100).toFixed(2);
    return format
      .replace(/\{\{\s*amount\s*\}\}/, amount)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100).toString())
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amount.replace('.', ','))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, Math.round(cents / 100).toString());
  }

  function selectedOptions() {
    var values = [];
    root.querySelectorAll('[data-option-index]').forEach(function (fieldset) {
      var checked = fieldset.querySelector('[data-option-input]:checked');
      values[parseInt(fieldset.getAttribute('data-option-index'), 10)] = checked ? checked.value : null;
    });
    return values;
  }

  function findVariant(values) {
    return product.variants.find(function (v) {
      return values.every(function (val, i) { return val === null || v.options[i] === val; });
    }) || null;
  }

  function scrollToMedia(mediaId) {
    if (!mediaId) return;
    var item = root.querySelector('.pdp-media__item[data-media-id="' + mediaId + '"]');
    var track = root.querySelector('[data-gallery-track]');
    if (item && track) track.scrollTo({ left: item.offsetLeft, behavior: 'smooth' });
    root.querySelectorAll('[data-thumb]').forEach(function (t) {
      t.classList.toggle('is-active', t.getAttribute('data-target-media') === String(mediaId));
    });
  }

  function updateUI(variant) {
    if (!variant) {
      if (atc) { atc.disabled = true; }
      if (atcLabel) atcLabel.textContent = 'Unavailable';
      if (stickyBtn) { stickyBtn.disabled = true; stickyBtn.textContent = 'Unavailable'; }
      return;
    }
    if (idInput) idInput.value = variant.id;

    if (priceWrap) {
      var current = priceWrap.querySelector('.price__current');
      var compare = priceWrap.querySelector('.price__compare');
      if (current) current.textContent = formatMoney(variant.price);
      var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
      priceWrap.classList.toggle('price--sale', !!onSale);
      if (onSale && !compare) {
        compare = document.createElement('s');
        compare.className = 'price__compare';
        priceWrap.appendChild(compare);
      }
      if (compare) {
        compare.hidden = !onSale;
        if (onSale) compare.textContent = formatMoney(variant.compare_at_price);
      }
    }
    if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price);

    if (availability) {
      availability.textContent = variant.available ? 'In stock' : 'Sold out';
      availability.classList.toggle('is-out', !variant.available);
    }
    if (atc) atc.disabled = !variant.available;
    if (atcLabel) atcLabel.textContent = variant.available ? 'Add to cart' : 'Sold out';
    if (stickyBtn) { stickyBtn.disabled = !variant.available; stickyBtn.textContent = variant.available ? 'Add to cart' : 'Sold out'; }

    root.querySelectorAll('[data-option-index]').forEach(function (fieldset) {
      var i = parseInt(fieldset.getAttribute('data-option-index'), 10);
      var label = fieldset.querySelector('[data-option-label]');
      if (label) label.textContent = variant.options[i];
    });

    if (variant.media_id) scrollToMedia(variant.media_id);

    if (window.history && window.history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }
  }

  if (picker) {
    picker.addEventListener('change', function (e) {
      if (!e.target.closest('[data-option-input]')) return;
      updateUI(findVariant(selectedOptions()));
    });
  }

  /* ---- Thumbnails ---- */
  root.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-thumb]');
    if (thumb) scrollToMedia(thumb.getAttribute('data-target-media'));
  });

  /* ---- Track scroll -> active thumb ---- */
  var track = root.querySelector('[data-gallery-track]');
  if (track) {
    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        var index = Math.round(track.scrollLeft / track.clientWidth);
        var item = track.children[index];
        if (item) {
          var id = item.getAttribute('data-media-id');
          root.querySelectorAll('[data-thumb]').forEach(function (t) {
            t.classList.toggle('is-active', t.getAttribute('data-target-media') === id);
          });
        }
        ticking = false;
      });
    }, { passive: true });
  }

  /* ---- Zoom ---- */
  var zoomModal = root.querySelector('[data-zoom-modal]');
  var zoomImg = root.querySelector('[data-zoom-img]');
  root.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-zoom-trigger]');
    if (trigger && zoomModal && zoomImg) {
      zoomImg.src = trigger.getAttribute('data-zoom-src');
      zoomImg.alt = trigger.getAttribute('data-zoom-alt') || '';
      zoomModal.hidden = false;
      document.body.style.overflow = 'hidden';
    }
    if (e.target.closest('[data-zoom-close]') || e.target === zoomModal) {
      zoomModal.hidden = true;
      zoomImg.src = '';
      document.body.style.overflow = '';
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && zoomModal && !zoomModal.hidden) {
      zoomModal.hidden = true;
      document.body.style.overflow = '';
    }
  });

  /* ---- Sticky mobile ATC ---- */
  var sticky = root.querySelector('[data-sticky-atc]');
  var buyBlock = root.querySelector('.pdp__buy');
  if (sticky && buyBlock && 'IntersectionObserver' in window) {
    sticky.hidden = false;
    var io = new IntersectionObserver(function (entries) {
      sticky.classList.toggle('is-visible', !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0);
    }, { threshold: 0 });
    io.observe(buyBlock);
  }

  /* ---- Related products (Section Rendering API) ---- */
  var related = document.querySelector('[data-related]');
  if (related && related.getAttribute('data-url')) {
    fetch(related.getAttribute('data-url'))
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var tpl = document.createElement('div');
        tpl.innerHTML = html;
        var next = tpl.querySelector('[data-related]');
        if (next && next.innerHTML.trim()) related.innerHTML = next.innerHTML;
      })
      .catch(function () { /* leave server-rendered fallback */ });
  }
})();
